import { ListChecks } from "lucide-react"

import type { Recipe } from "@/types/recipe"

type RecipeIngredientsProps = {
  recipe: Recipe
}

export function RecipeIngredients({ recipe }: RecipeIngredientsProps) {
  const ingredientsCount = recipe.ingredients.length

  return (
    <section
      id="ingredients"
      className="rounded-[2rem] border border-neutral-200 bg-white p-6 shadow-sm sm:p-8"
    >
      <div className="mb-6">
        <div className="eyebrow">Інгредієнти</div>

        <h2 className="mt-4 text-2xl font-semibold text-neutral-950 sm:text-3xl">
          Що знадобиться
        </h2>

        <p className="mt-3 text-sm leading-7 text-neutral-600 sm:text-base">
          Нижче зібраний список інгредієнтів для цього рецепта з базовими
          пропорціями. Перед початком зручно одразу підготувати все потрібне,
          щоб процес ішов спокійніше й без поспіху.
        </p>
      </div>

      <div className="mb-5 rounded-[1.5rem] border border-neutral-200 bg-neutral-50 p-4">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-800">
            <ListChecks className="h-5 w-5" />
          </div>

          <div>
            <div className="text-sm font-semibold text-neutral-950">
              Коротко перед стартом
            </div>
            <p className="mt-1 text-sm leading-7 text-neutral-600">
              У списку {ingredientsCount}{" "}
              {ingredientsCount === 1
                ? "позиція"
                : ingredientsCount >= 2 && ingredientsCount <= 4
                ? "позиції"
                : "позицій"}
              . Зручно спочатку перевірити, чи все є під рукою, а вже потім
              переходити до кроків приготування.
            </p>
          </div>
        </div>
      </div>

      <div className="overflow-hidden rounded-[1.5rem] border border-neutral-200">
        <ul className="divide-y divide-neutral-200">
          {recipe.ingredients.map((ingredient, index) => (
            <li
              key={`${ingredient.name}-${ingredient.amount}-${index}`}
              className="flex flex-col gap-1 bg-white px-5 py-4 sm:flex-row sm:items-start sm:justify-between"
            >
              <div className="min-w-0 pr-4">
                <div className="font-medium text-neutral-950">
                  {ingredient.name}
                </div>

                {ingredient.notes ? (
                  <div className="text-sm text-neutral-500">
                    {ingredient.notes}
                  </div>
                ) : null}
              </div>

              <div className="shrink-0 text-sm font-semibold text-emerald-800 sm:text-right">
                {ingredient.amount}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}